import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Container from "react-bootstrap/Container";
import Config from "../../_config/config";
import Form from "react-bootstrap/Form";
import Parser from "html-react-parser";
import OTPValidator from "../../_components/OTPValidator";
import { ILoader } from "../../_components/iloader/iloader";
import ApiService from "../../_services/ApiService";
import jwt_decode from "jwt-decode";
import { Modal } from "react-bootstrap";
import utils from "../../_helpers/utils";
import { AppPropertiesContext } from "../../contexts/app-properties.context";

import "./verify-mobile.styles.css";

class VerifyMobile extends React.Component {
  static contextType = AppPropertiesContext;
  constructor() {
    super();
    this.state = {
      mobile: "",
      error: false,
      errorMessage: "",
      otpMessage:
        "Successfully sent the One Time Password to your Registered Mobile Number",
      userId: "null",
      otpLength: 4,
      showOtpInput: false,
      showLoading: false,
      mobilePattern: /^[0-9]{10}$/,
      showTimer: false,
      resendOtp: false,
      callForOtp: false,
      timeLeft: Infinity,
      enableResendOtp: true,
      userDetails: {},
      showApplicationModal: false,
      studentCode: "",
      formId: "",
    };
    this.otpInterval = null;
  }

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  submitHandler = (e) => {
    e.preventDefault();
    this.checkMobile();
  };

  checkMobile = async () => {
    const { mobile: mobileNo, mobilePattern } = this.state;
    // console.log(mobilePattern.test(mobileNo));
    if (!mobilePattern.test(mobileNo)) {
      return this.setState({
        error: true,
        errorMessage:
          "Invalid Mobile Number. Please key in your 10 digit Indian mobile number (without the country code +91 )",
      });
    }

    try {
      this.setState({
        showLoading: true,
        error: false,
      });

      let search = window.location.search;
      if (search) search = `&${search.slice(1)}`;
      console.log(search, "here");

      const res = await ApiService.verifyMobile(mobileNo, search);
      console.log(res);
      const { studentCode } = res.data;
      // if (res?.data?.status === 200) {
      if (res?.data?.type === "success") {
        this.setState(
          {
            showOtpInput: true,
            showLoading: false,
            studentCode,
          },
          () => {
            this.startTimer("message");
          }
        );
      } else if (res?.data?.error_code === "E149") {
        this.setState({
          error: true,
          showLoading: false,
          errorMessage:
            "Sorry. This mobile number is not registered in our database. Did you use an alternative mobile number while signing up?",
          loginUserData: {},
        });
      } else {
        this.setState({
          showLoading: false,
          error: true,
          errorMessage: "Sorry some error occurred",
        });
      }
    } catch (e) {
      console.log(e);
      if (e.response.status === 404) {
        return this.setState({
          error: true,
          showLoading: false,
          errorMessage:
            "Sorry. This mobile number is not registered in our database. Did you use an alternative mobile number while signing up?",
          loginUserData: {},
        });
      }

      this.setState({
        error: true,
        showLoading: false,
        errorMessage: "Sorry some error occurred",
      });
    }
  };

  handleResendMessage = async () => {
    try {
      const { mobile } = this.state;
      const res = await ApiService.resendTextOtp(mobile);
      console.log(res);
      if (res.data.type === "success") {
        this.startTimer("call");
      } else {
        this.setState({
          showOtpInput: false,
          error: true,
          showLoading: false,
          errorMessage: res.data?.message || "Sorry some error occurred",
          loginUserData: {},
        });
      }
    } catch (e) {
      this.setState({
        showOtpInput: false,
        error: true,
        showLoading: false,
        errorMessage: "Sorry some error occurred",
        loginUserData: {},
      });
    }
  };

  handleCallForOtp = async () => {
    try {
      const { mobile } = this.state;
      const res = await ApiService.resendCallOtp(mobile);
      console.log(res);
      if (res.data.type === "success") {
        this.setState({
          resendOtp: false,
          callForOtp: false,
          showTimer: false,
          timeLeft: Infinity,
          enableResendOtp: false,
        });
      } else {
        this.setState({
          showOtpInput: false,
          error: true,
          showLoading: false,
          errorMessage: res.data?.message || "Sorry some error occurred",
          loginUserData: {},
        });
      }
    } catch (e) {
      this.setState({
        showOtpInput: false,
        error: true,
        showLoading: false,
        errorMessage: "Sorry some error occurred",
        loginUserData: {},
      });
    }
  };

  handleOtpSubmit = async (otp, isSubmitted) => {
    this.setState({
      showOtpInput: false,
    });

    if (!isSubmitted) return;

    this.setState({
      showLoading: true,
    });

    console.log(otp);
    // const otpData = {
    //   channel: "mobile",
    //   identifier: this.state.mobile,
    //   otp,
    // };
    const { mobile } = this.state;
    const { registrationForms } = this.context;
    console.log(registrationForms);

    let search = window.location.search;
    if (search) search = `&${search.slice(1)}`;
    console.log(search, "here");

    try {
      const res = await ApiService.loginWithOtp(mobile, otp, search);
      this.setState({
        showLoading: false,
      });
      console.log(res);
      const { token } = res.data || {};

      if (res.data.status === 404) {
        let formId = "";
        const { studentCode } = this.state;
        if (registrationForms.length > 1) {
          try {
            const res = await ApiService.getUserFormId(studentCode);
            formId = res.data["form-id"]?.trim();
          } catch (error) {
            console.log(error);
            return this.setState({
              error: true,
              showLoading: false,
              errorMessage:
                "I'm sorry, it appears that I am still in the process of receiving data and your records are not yet accessible to me. Please try again in 24 hours. Thank you for your understanding and patience.",
              loginUserData: {},
            });
          }
        }

        return this.setState({
          error: true,
          showLoading: false,
          errorMessage:
            "Sorry. This mobile number is not registered in our database. Did you use an alternative mobile number while signing up?",
          loginUserData: {},
          showApplicationModal: true,
          formId,
        });
      }

      if (token) {
        // this.loginToken(token, res.data.data);
        return this.dologin(token, res.data.data);
      } else {
        this.setState({
          error: true,
          showLoading: false,
          errorMessage: "Invalid Otp",
          loginUserData: {},
        });
      }
    } catch (e) {
      this.setState({
        error: true,
        showLoading: false,
        errorMessage: "Sorry some error occurred",
        loginUserData: {},
      });
    }
  };

  startTimer = (event) => {
    this.setState(
      {
        enableResendOtp: true,
        resendOtp: false,
        callForOtp: false,
        showTimer: true,
        timeLeft: 30,
      },
      () => {
        this.otpInterval = setInterval(() => {
          if (this.state.timeLeft === 1) {
            clearInterval(this.otpInterval);
            this.setState({
              resendOtp: event === "message",
              showTimer: false,
              callForOtp: event === "call",
            });
          } else {
            this.setState((prevState) => ({
              timeLeft: prevState.timeLeft - 1,
            }));
          }
        }, 1000);
      }
    );
  };

  componentWillUnmount() {
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
    }
  }

  loginToken(token, testDetails) {
    if (token) {
      console.log(token);
      this.setState(
        { loading: true, loaderStyle: "dark", connectionErrorMsg: null },
        () => {
          ApiService.fetchLoginToken(token).then(
            (res) => {
              console.log(res, "<--login");
              if (res.data.status === 1) {
                this.setState(
                  { loading: false, loginUserData: res.data.data },
                  () => {
                    this.dologin(testDetails);
                  }
                );
              } else {
                this.setState({
                  loading: false,
                  errorMessage: res.data.message,
                });
              }
            },
            (error) => {
              //ErrorCB
              this.setState({
                loading: false,
                connectionErrorMsg: Config.CONNECTION_ERROR_MSG,
              });
            }
          );
        }
      );
    }
  }

  dologin = (token, testDetails) => {
    // let loginUserData = this.state.loginUserData;
    let user = jwt_decode(token);
    delete user.sub;
    delete user.jti;
    delete user.iat;
    user.token = token;
    console.log(user, "<--decoded");
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("enquiryId", user.enquiryId);
    localStorage.setItem("tenant", user.tenant);

    const homeRoute = sessionStorage.getItem("homeRoute");

    return this.props.history.replace({
      pathname: homeRoute || "/testdetails",
      state: { testDetails },
    });
  };

  handleChangeSelect = (e) => {
    const { name } = e.target;
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const id = el.getAttribute("id");
    this.setState((prevState) => ({
      userDetails: {
        ...prevState.userDetails,
        [name]: id,
      },
    }));
  };

  handleApplicationFormChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      userDetails: {
        ...prevState.userDetails,
        [name]: value,
      },
    }));
  };

  closeApplicationModal = () => {
    this.setState({
      showApplicationModal: false,
    });
  };

  getMonthFromString=(mon)=>{

    var d = Date.parse(mon + "1, 2012");
    if(!isNaN(d)){
       return new Date(d).getMonth() + 1;
    }
    return -1;
  }

  getDateFromBatchDisplay = (display) => {
    // req format example 1st  October: ONLINE : 1PM - 2PM / 1st  October: OFFLINE

    const displayArr = display.split(":");
    console.log(displayArr, "arrr");

    let time = null;
    if (displayArr[2]) {
      const timeArr = displayArr[2].split("-");

      time = timeArr[0].trim();
    }

    const dateArr = displayArr[0].trim().split(" ");

    const day = dateArr[0].trim().slice(0, dateArr[0].length - 2);

    const month = this.getMonthFromString(dateArr[dateArr.length -1]);

    const currentDate = new Date();

    let year = currentDate.getFullYear();

    const currentMonth = currentDate.getMonth();

    if(month< currentMonth){
      year +=1;
    }
    

    const date = `${day}/${month}/${year}`;

    return {
      date,
      time,
    };
  };

  getCourseDetails = (userDetails) => {
    const { registrationForms } = this.context;
    const registrationForm = this.state.formId
      ? registrationForms.find(
          (form) =>
            form["form-id"]?.toLowerCase() === this.state.formId.toLowerCase()
        )
      : registrationForms[0];

    const courseDetails = registrationForm.batches?.find(
      (batch) => batch.id.toString() === userDetails.batchId
    );

    return courseDetails || null;
  };

  sendSuccessfulRegistrationMsg = async (userDetails) => {
    const {mobile} = this.state;
    const userCourseDetails = this.getCourseDetails(userDetails);
    const { date, time } = this.getDateFromBatchDisplay(
      userCourseDetails?.display
    );
    try{
      const res = await ApiService.sendRegistrationMessage(mobile, userDetails.studentName, date, time);
      console.log(res);
    }catch(error){
      console.log(error)
    }
  };

  handleApplicationFormSubmit = async (e) => {
    const { registrationForms } = this.context;
    e.preventDefault();
    const { userDetails, studentCode, formId } = this.state;

    const search = window.location.search;
    const params = new URLSearchParams(search);
    let queryParams = {};
    for (var value of params.keys()) {
      queryParams[value] = params.get(value);
    }

    const body = {
      ...userDetails,
      mobileNumber: studentCode,
      studentCode: "AUTO",
      "form-id": formId,
      queryParams,
    };
    // console.log(body, "here");

    try {
      const res = await ApiService.saveUserData(body);
      console.log(res);
      const { token } = res.data;
      if ("token") {
        await this.sendSuccessfulRegistrationMsg(userDetails);
        this.dologin(token);
      } else {
        this.setState({
          error: true,
          showLoading: false,
          errorMessage: "Something went wrong while saving",
          loginUserData: {},
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({
        error: true,
        showLoading: false,
        errorMessage: "Something went wrong while saving",
        loginUserData: {},
      });
    } finally {
      this.closeApplicationModal();
    }
  };

  render() {
    const { registrationForms, loginText1 } = this.context;
    console.log(registrationForms, "forms");
    const registrationForm = this.state.formId
      ? registrationForms.find((form) => {
          console.log(
            form["form-id"] === this.state.formId,
            form["form-id"],
            this.state.formId,
            "forms"
          );
          return (
            form["form-id"]?.toLowerCase() === this.state.formId.toLowerCase()
          );
        })
      : registrationForms[0];
    console.log(registrationForm, "forms");
    registrationForm?.batches?.sort((a, b) => a.sortOrder - b.sortOrder);
    registrationForm?.preferredCentres?.sort(
      (a, b) => a.sortOrder - b.sortOrder
    );
    const isMobile = utils.isMobileDevice();
    const loginFooter = sessionStorage.getItem("loginFooter");
    console.log(loginFooter, "loginFooter");
    return (
      <div className="login work-sans-font">
        <Modal
          className="test-result-application-modal"
          show={this.state.showApplicationModal}
          onHide={() => {}}
        >
          <form onSubmit={this.handleApplicationFormSubmit}>
            <Modal.Header className="result-application-modal-header">
              {/* <h3 className="registration-form-text">{registrationForm?.text}</h3> */}
              <div
                dangerouslySetInnerHTML={{ __html: registrationForm?.text }}
              />
            </Modal.Header>
            <Modal.Body>
              <div className="test-result-application-wrapper">
                {registrationForm?.firstName?.enabled && (
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      type="text"
                      name="studentName"
                      onChange={this.handleApplicationFormChange}
                      required
                      placeholder=" "
                    />
                    <label>* {registrationForm?.firstName?.display}</label>
                  </div>
                )}
                {Object?.entries(registrationForm || {}).map((entry) => {
                  const [key, value] = entry;
                  if (key === "firstName") return null;
                  if (key === "batch") return null;
                  if (key === "preferredcentre") return null;
                  if (key === "dropdowns") return null;
                  if (key === "form-id") return null;
                  if (key === "text") return null;
                  if (key === "course") return null;

                  if (!value.enabled) return null;
                  return (
                    <div className="form-floating mb-3">
                      <input
                        type={value.type || "text"}
                        name={key}
                        onChange={this.handleApplicationFormChange}
                        placeholder=" "
                        className="form-control"
                        required={value.mandatory === false ? false : true}
                      />
                      <label>
                        {value.mandatory === false ? "" : "* "}
                        {value?.display}
                      </label>
                    </div>
                  );
                })}
                {registrationForm?.course?.enabled && (
                  <div className="test-result-application-div">
                    <label>* {registrationForm?.course?.display}</label>
                    <select
                      className="form-select"
                      // className="user-registration-select"
                      name="courseId"
                      onChange={this.handleChangeSelect}
                      required
                    >
                      <option disabled selected value="">
                        {" "}
                        -- select an option --{" "}
                      </option>
                      {registrationForm?.courses?.map((course) => (
                        <option id={course.id} value={course.id}>
                          {course.display}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {registrationForm?.batch?.enabled && (
                  <div className="test-result-application-div">
                    <label>* {registrationForm?.batch?.display}</label>
                    <select
                      // className="user-registration-select"
                      className="form-select"
                      name="batchId"
                      onChange={this.handleChangeSelect}
                      required
                    >
                      <option disabled selected value="">
                        {" "}
                        -- select an option --{" "}
                      </option>
                      {registrationForm?.batches?.map((batch) => {
                        return !batch.restrictTo ||
                          batch.restrictTo?.courseId?.toString() ===
                            this.state.userDetails.courseId?.toString() ? (
                          <option id={batch.id} value={batch.id}>
                            {batch.display}
                          </option>
                        ) : null;
                      })}
                    </select>
                  </div>
                )}
                {registrationForm?.preferredcentre?.enabled &&
                  (!registrationForm?.preferredcentre?.restrictTo ||
                    registrationForm?.preferredcentre?.restrictTo?.batchId
                      ?.toString()
                      ?.includes(this.state.userDetails.batchId)) && (
                    <div className="test-result-application-div">
                      <label>
                        * {registrationForm?.preferredcentre?.display}
                      </label>
                      <select
                        // className="user-registration-select"
                        className="form-select"
                        name="centreId"
                        onChange={this.handleChangeSelect}
                        required
                      >
                        <option disabled selected value="">
                          {" "}
                          -- select an option --{" "}
                        </option>
                        {registrationForm?.preferredCentres?.map((center) => (
                          <option id={center.id} value={center.id}>
                            {center.display}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                {registrationForm?.dropdowns?.map((dropdown) =>
                  dropdown.enabled ? (
                    <div className="test-result-application-div">
                      <label>* {dropdown.display}</label>
                      <select
                        // className="user-registration-select"
                        className="form-select"
                        name={dropdown.name}
                        onChange={this.handleChangeSelect}
                        required
                      >
                        <option disabled selected value="">
                          {" "}
                          -- select an option --{" "}
                        </option>
                        {dropdown.values?.map((value) => (
                          <option id={value.id} value={value.id}>
                            {value.display}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : null
                )}
              </div>
            </Modal.Body>
            <Modal.Footer className="result-application-modal-footer">
              <button className="btn btn-success">Submit</button>
            </Modal.Footer>
          </form>
        </Modal>

        {
          <Container
            fluid
            style={{
              height: "100vh",
              display: "flex",
              "align-items": "center",
              "justify-content": "center",
              background: `url(https://tuningfork-live.s3.ap-southeast-1.amazonaws.com/${Config.siteTitle}/files/logos/watermark1.jpg)`,
            }}
          >
            {/*
            !isMobile&&
          <img
                style={{
                  marginLeft: this.state.userObject?.photoPath ? "30px" : "0px",
                }}
                className="test-player-logo-img verify-mobile-logo"
                src={`https://webfront.edusquares.com/${Config.siteTitle}/files/logos/logo.png`}
                alt="logo"
              />
              */}
            {isMobile && (
              <div
                className="header-image"
                style={{
                  background: `url(${Config.cover}) no-repeat transparent`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
            )}
            <div className="main-content main-content-verify-mobile">
              <div className="logo-wrapper">
                <img
                  style={{
                    marginLeft: this.state.userObject?.photoPath
                      ? "30px"
                      : "0px",
                  }}
                  className="test-player-logo-img verify-mobile-logo"
                  src={`https://webfront.edusquares.com/${Config.siteTitle}/files/logos/logo.png`}
                  alt="logo"
                />
              </div>

              <span className="mobile-no-text">
                <strong>{loginText1 || "Enter Your Mobile number"}</strong>
              </span>
              <br />
              {
                <Form onSubmit={this.submitHandler}>
                  <Form.Group>
                    <div
                      className={`item-inner ${
                        this.state.error ? "has-error" : ""
                      }`}
                    >
                      <Form.Control
                        type="tel"
                        name="mobile"
                        onChange={this.onChange}
                        placeholder="Mobile Number"
                        title="please enter a valid phone no"
                        value={this.state.mobile}
                      />
                    </div>
                    <br />
                    <div className="institute-sign-in-btn">
                      <input
                        className="send-otp-button button-full button-md"
                        type="submit"
                        value="Send Otp"
                      />
                    </div>
                    {this.state.error && (
                      <div className="red">
                        {Parser(this.state.errorMessage)}
                      </div>
                    )}
                  </Form.Group>
                </Form>
              }
            </div>
          </Container>
        }
        <OTPValidator
          data={{
            show: this.state.showOtpInput,
            otpLength: this.state.otpLength,
            smsAddress: this.state.mobile,
            message: this.state.otpMessage,
            userId: this.state.userId,
          }}
          handleResendMessage={this.handleResendMessage}
          enableResendOtp={this.state.enableResendOtp}
          showTimer={this.state.showTimer}
          masterControl={true}
          timeLeft={this.state.timeLeft}
          resendOtp={this.state.resendOtp}
          callForOtp={this.state.callForOtp}
          onOTPValidatorClose={this.handleOtpSubmit}
          handleCallForOtp={this.handleCallForOtp}
        />
        <ILoader
          loadingText={"Please wait..."}
          isShow={this.state.showLoading}
        ></ILoader>
        {loginFooter && (
          <div className="verify-mobile-support">
            {loginFooter}
            {/* <span className="verify-mobile-support-email">
            help@unacademy.com
          </span>{" "} */}
          </div>
        )}
      </div>
    );
  }
}

export default VerifyMobile;
